import { render, staticRenderFns } from "./remind-popup.vue?vue&type=template&id=5c3afdf8&scoped=true&"
import script from "./remind-popup.vue?vue&type=script&lang=js&"
export * from "./remind-popup.vue?vue&type=script&lang=js&"
import style0 from "./remind-popup.vue?vue&type=style&index=0&id=5c3afdf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3afdf8",
  null
  
)

export default component.exports